// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rptHistoryPnl{max-height:500px;width:800px}.rptHistoryPnl.container{padding:0}.jobCard:hover{cursor:pointer}.jobCard .jobContent{width:90%}.jobCard .jobAction{width:10%;text-align:center}.jobCard .rptKeys{padding-left:20px}.jobCard .v-expansion-panel__header{height:auto!important}", ""]);
// Exports
module.exports = exports;
